import { useCallback, useState } from 'react';
import _ from 'lodash';

import { SnackbarState } from '@/modules/core/core.types';
import { useSnackbar } from '@/modules/core/hooks';
import { TriggerCategoryType } from '@/modules/HealthPlan/HealthPlan.types.ts';
import { AddTriggerFormValues } from '@/modules/HealthPlan/HealthPlanSetup/ComplexConfiguration/EnrollmentMatrix/ProcessingRuleModalV2/ProcessingRuleModal.types';

import useCreateTriggerQuery from '../queries/useCreateTrigger.query';

interface Params {
  onCreated: (triggerId: string, triggerType: TriggerCategoryType) => void;
  onClose: () => void;
}

const useAddTriggerSubmit = ({ onCreated, onClose }: Params) => {
  const [isServerError, setServerError] = useState(false);
  const { handleAddPermanentSnackbar } = useSnackbar();

  const { createTrigger, isLoading } = useCreateTriggerQuery((created) => {
    if (!created.trigger_category_type) return;
    onCreated(_.toString(created.id), created.trigger_category_type);
    onClose();
    handleAddPermanentSnackbar({
      text: 'New trigger was added',
      closeIcon: true,
      state: SnackbarState.positive,
    });
  });

  const handleSubmit = useCallback(
    async (values: AddTriggerFormValues) => {
      try {
        await createTrigger(values.triggerName.trim(), values.triggerType);
      } catch {
        setServerError(true);
      }
    },
    [createTrigger]
  );

  return { handleSubmit, isLoading, isServerError, setServerError };
};

export default useAddTriggerSubmit;
